import { jsx, jsxs } from "react/jsx-runtime";
import { useFormContext, Controller } from "react-hook-form";
import InputAdornment from "@mui/material/InputAdornment/index.js";
import Typography from "@mui/material/Typography/index.js";
import "lottie-react";
import "../../themes/shadows/shadows.js";
import "../../themes/typography/typography.js";
import "react";
import "../avatar-group/avatar-group.styles.js";
import "@mui/material";
import "../date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../date-pickers/date-picker/theme/index.js";
import "../dialog/dialog.js";
import "../icons/all/all.js";
import "../label/label.styles.js";
import { MenuItem } from "../menu-item/menu-item.js";
import "../slider/slider.styles.js";
import "@mui/material/styles";
import "../snackbar/snackbar.styles.js";
import "../styled-text-field/styled-text-field.styles.js";
import "../swipeable-drawer/swipeable-drawer.js";
import "../translations/utils.js";
import "../time-interval-select/time-interval-select.styles.js";
import { getTimeSelectOptions, END_OF_DAY, MINUTES_STEP } from "./time-select.hepers.js";
import { StyledFormControl, StyledInputLabel, StyledSelect, StyledTimerIcon } from "./time-select.styles.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../constants/create-theme/create-theme.js";
import "../../constants/colors/palette.js";
import "../../themes/button/button.js";
import "../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../themes/button/styles/external/filled.styles.js";
import "../../themes/button/styles/internal/bordered.styles.js";
import "../../themes/button/styles/internal/borderless.styles.js";
import "../../themes/button/styles/internal/filled.styles.js";
import "../../themes/button/styles/internal/shadowed.styles.js";
import "../date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../themes/date-calendar/date-calendar.js";
import "../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../themes/day-calendar/day-calendar.js";
import "../../themes/filled-input/filled-input.js";
import "../../themes/form-helper-text/form-helper-text.js";
import "../../themes/form-label/form-label.js";
import "../../themes/month-calendar/month-calendar.js";
import "../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../themes/pickers-month/pickers-month.js";
import "../../themes/pickers-popper/pickers-popper.js";
import "../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../themes/pickers-year/pickers-year.js";
import "../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../themes/alert/alert.js";
import "../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../themes/dialog/dialog.js";
import "../../themes/external-theme/external-theme.js";
import "../../constants/breakpoints/breakpoints.js";
import "../../themes/checkbox/checkbox.js";
import "../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../themes/form-control-label/form-control-label.js";
import "../../themes/radio/radio.js";
import "../../themes/switch/switch.js";
import "../../themes/popover/popover.js";
import "../../themes/tooltip/tooltip.js";
import "../dialog/dialog.constants.js";
import "../dialog/dialog.styles.js";
import "@emotion/react";
import "../dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../icons/CalendarEventIcon/CalendarEventIcon.js";
import "../icons/MainIcon/MainIcon.js";
import "../icons/CalendarIcon/CalendarIcon.js";
import "../icons/CardIcon/CardIcon.js";
import "../icons/ChecklistIcon/ChecklistIcon.js";
import "../icons/ClockIcon/ClockIcon.js";
import "../icons/CloseIcon/CloseIcon.js";
import "../icons/EditIcon/EditIcon.js";
import "../icons/EmptyCalendar/EmptyCalendar.js";
import "../icons/EventNote/EventNote.js";
import "../icons/FilterIcon/FilterIcon.js";
import "../icons/ListIcon/ListIcon.js";
import "../icons/MessageBubble/MessageBubble.js";
import "../icons/PhoneIcon/PhoneIcon.js";
import "../icons/PinIcon/PinIcon.js";
import "../icons/SearchIcon/SearchIcon.js";
import "../icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../icons/TimerIcon/TimerIcon.js";
import "../icons/TreatmentChairIcon/TreatmentIcon.js";
import "../icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../menu-item/components/menu-item-counter/menu-item-counter.js";
import "../menu-item/assets/icons/minus-circle.js";
import "../menu-item/assets/icons/plus-circle.js";
import "../menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../menu-item/menu-item.styles.js";
import "../avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../snackbar/snackbar.types.js";
import "../text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../text-field/text-field.styles.js";
import "../swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/material/Box/index.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
const TimeSelect = ({
  name,
  label,
  startFrom = 0,
  endTo = END_OF_DAY,
  step = MINUTES_STEP,
  disabled,
  required
}) => {
  const { control } = useFormContext();
  const options = getTimeSelectOptions({ startFrom, endTo, step });
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name,
      render: ({ field: { ref, ...field } }) => /* @__PURE__ */ jsxs(StyledFormControl, { variant: "standard", required, children: [
        /* @__PURE__ */ jsx(StyledInputLabel, { id: `${name}-select-label`, shrink: !!field.value, children: label }),
        /* @__PURE__ */ jsx(
          StyledSelect,
          {
            ...field,
            labelId: `${name}-select-label`,
            id: `${name}-select`,
            label,
            inputRef: ref,
            disabled,
            inputProps: {
              "data-testid": `${name}-select`
            },
            startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(StyledTimerIcon, {}) }),
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: "6px",
                  borderBottomRightRadius: "6px"
                }
              }
            },
            children: options.map((option) => /* @__PURE__ */ jsx(MenuItem, { value: option, children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: option }) }, option))
          }
        )
      ] })
    }
  );
};
export {
  TimeSelect as default
};
